import { Box } from "@mui/material";
import React from "react";
import TefExport from "./export/tefExport";
import AleExport from "./export/aleExport";
import TlmExport from "./export/tlmExport";
import ProbaExport from "./export/probaExport";
import HeatmapExport from "./export/heatmapExport";
import AssetsExport from "./export/assetsExport";
import WeaknessExport from "./export/weaknessExport";
import CostExport from "./export/costExport";
import DiscoveredAssetsExport from "./export/discoveredAssetsExport";
import ReferenceExport from "./export/referenceExport";
import OrgaDescription from "./export/orgaDescription";

export default function Export({
  tefData,
  aleData,
  tlmData,
  costData,
  probaData,
  heatmapData,
  assetsData,
  weaknessesData,
  discoveredAssestsData,
  referencesData,
  orgaDescriptionData
}) {
  // Function to handle PDF export

  return (
    <Box sx={{ bgcolor: "#f9f9f9"}}>
      {/* Export Button */}
      <Box id="export-content" sx={{ padding: 2,bgcolor: "#f9f9f9" }}>

      {orgaDescriptionData && (
          <div style={{ margin: "5px" }}>
            <OrgaDescription data={orgaDescriptionData}/>
          </div>
        )}

      {discoveredAssestsData && (
          <div style={{ margin: "5px" }}>
            <DiscoveredAssetsExport export={true} discoveredAssetsData={discoveredAssestsData}/>
          </div>
        )}


      {/* Content to Export */}
      {tefData?.length > 0 && (
          <div id="tef-export" style={{ margin: "5px" }}>
            <TefExport tefData={tefData} />
          </div>
        )}
        


      {probaData && (
        <div style={{ margin: "5px" }}>
          <ProbaExport probaData={probaData} />
        </div>
      )}
      
      {costData && (
        <div style={{ margin: "5px" }}>
          <CostExport  data={costData} />
        </div>
      )}

      {tlmData && (
          <div id="tlm-export" style={{ margin: "5px" }}>
            <TlmExport data={tlmData}  />
          </div>
      )}
      


      {aleData?.length > 0 && (
        <div id="ale-export" style={{ margin: "5px" }}>
          <AleExport data={aleData} />
        </div>
      )}



        {heatmapData?.length > 0 && (
          <div style={{ margin: "5px" }}>
            <HeatmapExport heatmapData={heatmapData} />
          </div>
        )}
        {/* {assetsData?.length > 0 && (
          <div style={{ margin: "5px" }}>
            <AssetsExport assetsData={assetsData} />
          </div>
        )} */}

        {weaknessesData && (
          <div style={{ margin: "5px" }}>
            <WeaknessExport weaknessesData={weaknessesData} />
          </div>
        )}
        {referencesData && (
          <div style={{ margin: "5px" }}>
            <ReferenceExport data={referencesData} />
          </div>
        )}
      </Box>
    </Box>
  );
}
